import React, { useState, useContext } from 'react';
import T from './theme';
import CardDndContext from './CardDndContext';

export default function CollapsibleCard({ title, accentColor, defaultOpen = true, children }) {
  const dnd = useContext(CardDndContext);
  const [localOpen, setLocalOpen] = useState(defaultOpen);

  const open = dnd ? dnd.isOpen : localOpen;
  const toggle = dnd ? dnd.onToggle : () => setLocalOpen((o) => !o);

  return (
    <div className="card" style={{ ...T.cardStyle, borderLeftColor: accentColor }}>
      <h2
        onClick={toggle}
        style={{ margin: 0, cursor: 'pointer', userSelect: 'none' }}
        {...(dnd ? dnd.dragHandleProps : {})}
      >
        {title} <span className="chevron">{open ? '\u25BE' : '\u25B8'}</span>
      </h2>
      {open && children}
    </div>
  );
}
